import { render, staticRenderFns } from "./ControlPostcode.vue?vue&type=template&id=950152b0"
import script from "./ControlPostcode.vue?vue&type=script&lang=js"
export * from "./ControlPostcode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports